import { render, staticRenderFns } from "./commonSchoolTree.vue?vue&type=template&id=5ae03102&scoped=true"
import script from "./commonSchoolTree.vue?vue&type=script&lang=js"
export * from "./commonSchoolTree.vue?vue&type=script&lang=js"
import style0 from "./commonSchoolTree.vue?vue&type=style&index=0&id=5ae03102&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae03102",
  null
  
)

export default component.exports